import { render, staticRenderFns } from "./prd_data.vue?vue&type=template&id=77858d4a&scoped=true"
import script from "./prd_data.vue?vue&type=script&lang=js"
export * from "./prd_data.vue?vue&type=script&lang=js"
import style0 from "./prd_data.vue?vue&type=style&index=0&id=77858d4a&prod&scoped=true&lang=less"
import style1 from "./prd_data.vue?vue&type=style&index=1&id=77858d4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77858d4a",
  null
  
)

export default component.exports